import { useLanguage } from "@/contexts/LanguageContext";

const About = () => {
  const { t } = useLanguage();
  return (
    <div className="max-w-4xl mx-auto px-6 lg:px-12 py-20 md:py-28" data-testid="about-page">
      <p className="font-script text-camel text-2xl">L'atelier</p>
      <h1 className="font-serif-display text-5xl md:text-6xl text-ink mt-1">{t.about.title}</h1>
      <p className="font-body text-base md:text-lg text-muted-foreground mt-8 leading-relaxed max-w-2xl whitespace-pre-line">
        {t.about.body}
      </p>
      <blockquote className="mt-16 border-l-2 border-terracotta pl-6">
        <p className="font-serif-display text-3xl md:text-4xl text-ink leading-snug italic">
          "{t.about.quote}"
        </p>
        <footer className="font-script text-2xl text-terracotta mt-4">{t.about.sign}</footer>
      </blockquote>
    </div>
  );
};

export default About;
